var _PopupContentServiceInit_contents;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
class PopupContentServiceInit {
    constructor() {
        _PopupContentServiceInit_contents.set(this, writable([]));
    }
    get contents() {
        return __classPrivateFieldGet(this, _PopupContentServiceInit_contents, "f");
    }
    addContent(content) {
        __classPrivateFieldGet(this, _PopupContentServiceInit_contents, "f").update((it) => [...it, content]);
    }
    removeContent(content) {
        __classPrivateFieldGet(this, _PopupContentServiceInit_contents, "f").update((it) => it.filter((c) => c !== content));
    }
}
_PopupContentServiceInit_contents = new WeakMap();
export const PopupContentService = new PopupContentServiceInit();
